export default "__VITE_ASSET__ii21T05R__"